// removed by extract-text-webpack-plugin
module.exports = {"Page":"_3U5m3ut0Axp2LtqZ0GnwIV","TitleBar":"_253UC2cwDl7lMcLISdz7Z6","Division":"_2kjZcExTqYmmCJ-lnHbDka","DivisionHeader":"Q-AzUUdyyQHnlgu1PDQp_","RightControls":"_2vKnBNsqExJ1wIvf_1q3DG","Footer":"wTEFkIe__tqbUW58ceAMm"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Reports/Pay/index.css
// module id = 942
// module chunks = 0